<template>
    <div v-if="show" class="mask">
        <div  class="form-modal doc-edit-modal flex flex-col flex-space-between book">
            <div class="flex flex-space-between flex-center-cz title border-box">
                <div class="margin-left-l font-s">{{title}}</div>
                <img src="@/assets/images/guanbi.png" class="logo-18 margin-right-m pointer" @click="close"/>
            </div>
            
            <div class="flex flex-col body padding-top-l border-box " style="height: calc(100% - 100px)" >
                <div class="flex flex-col margin-top-m">
                    <div class="flex flex-center-cz  edit-area margin-top-m">
                        <div class="label">名称</div>
                        <div class="value"> <input class="ui-input full-width" type="text" v-model="formData.name" /></div>
                    </div>
                    <div class="flex flex-center-cz  edit-area margin-top-m">
                        <div class="label">内容</div>
                        <div class="value" > <RichText ref="rtf"  class="full-width" v-model="formData.content" /></div>
                    </div>
                </div>
            </div>
            <div class="flex flex-center-sp flex-center-cz toolbar border-box">
                <div v-if="false" class="margin-right-s ui-no-button flex flex-center-cz flex-center-sp" @click="close">取消</div>
                <div v-if="false" class="margin-right-s ui-no-button flex flex-center-cz flex-center-sp" @click="insert()">插入</div>
                <div class="margin-right-s ui-no-button flex flex-center-cz flex-center-sp" @click="logs()">历史版本</div>
                <div class="margin-right-s ui-no-button flex flex-center-cz flex-center-sp" @click="sendUpdate">下发更新</div>
                <div class="margin-right-s ui-no-button flex flex-center-cz flex-center-sp" @click="contentdo($event)">内容处理</div>
                <div class="margin-left-s ui-yes-button flex flex-center-cz flex-center-sp" @click="confirm">确定</div>          
            </div>
            <popup-menu ref="opMenu" :menuData="opMenuData"  @menuClick="opMenuClick"></popup-menu>
            <SendUpdateModal :mData="formData" :open="showSendUpdateModal" @close="showSendUpdateModal = false" @confirm="sendUpdateConfirm" ></SendUpdateModal>
            <FileLogModal :open="showFileLogModal" @close="showFileLogModal = false" :logs="formData.editLogs"  ></FileLogModal>
            <!-- <InsertTestModal  ref="insertTestModal" :open="showInsertTestModal" @open="showInsertTestModal = true"  
                              @close="showInsertTestModal = false"  @add="insertTestConfirm"></InsertTestModal>
            <input hidden accept="*.xlsx" type="file" ref="testFileAdd" @change="getTestFile" />
            <InsertQuestionModal  ref="insertQuestionModal" :open="showInsertQuestionModal" @open="showInsertQuestionModal = true"  
            @close="showInsertQuestionModal = false"  @add="insertQuestionConfirm"></InsertQuestionModal> -->


        </div>
    </div>
</template>

<script>
    import RichText from '@/components/richText/RichText' 
    import {objToStr,keepContent,sortContent} from '@/utils/sysUtils'
    import PopupMenu from '@/components/popupMenu/PopupMenu' 
    import SendUpdateModal from '@/views/modal/SendUpdateModal'
    import FileLogModal from '@/views/modal/FileLogModal'
    import {sendMsgs,editLogs, saveAllHtml,getTestHtml,createDoc,getMyFile,getQuestionHtml} from '@/api/api.js';
    import { EventBus } from "@/EventBus";
    import InsertTestModal from '@/views/plugs/InsertTestModal'
    import { getUUID } from '../../utils/sysUtils'
    import { getJsDate, getNowDate } from '../../utils/dateUtils'
    import InsertQuestionModal from '../plugs/InsertQuestionModal.vue'
    
    

    export default {
        name:'DocEditModal',
        created() {
            // EventBus.$on('insertTest', (data) => {
            //     let newId = getUUID()
            //     let nowDate = getNowDate();
            //     if (!this.formData.id) {
            //         if (!this.formData.name || this.formData.name == null || this.formData.name == "") {
            //             this.formData.name = "未命名"
            //         }
            //         if (!this.formData.content || this.formData.content == null ||  this.formData.content == "") {
            //             this.formData.content = "<span>&nbsp;</span>"
            //         }
                    
            //         createDoc(this.formData.name, this.formData.content, 'test', this.formData.parentId).then((res) => {
            //             if (res.data.success == true) {
            //                 console.log("res.data===================",res.data);
            //                 let docData = res.data.result;
            //                 this.$forceUpdate();                         
            //                 this.$emit("refresh",  docData);
            //                 getMyFile(docData.id).then((res1) => {
            //                     console.log("getMyFile=====", res1.data)
            //                     this.formData = res1.data.result;
            //                     this.formData.name = docData.name;
            //                     let fileId = this.formData.id;
            //                     this.$refs.insertTestModal.newForm({id: newId, date: nowDate, fileId: fileId, status:"未完成", finish:"完成"});
            //                 })                            
            //             }
            //         }) 

            //     } else {
            //         let fileId = this.formData.id;
            //         this.$refs.insertTestModal.newForm({id: newId, date: nowDate, fileId: fileId, status:"未完成", finish:"完成"});
            //     }
                
            // });
            // EventBus.$on('insertErrorBook', (data) => {
            //     console.log("insertErrorBook")
            // });
            // EventBus.$on('insertDcwj', (data) => {
            //     console.log("insertDcwj")
            // });
            // EventBus.$on('insertQuestion', (data) => {
            //     //let newId = getUUID()
            //     //let nowDate = getNowDate();
            //     //let fileId = this.formData.id;                
            //     let newId = getUUID()
            //     let nowDate = getNowDate();
            //     if (!this.formData.id) {
            //         if (!this.formData.name || this.formData.name == null || this.formData.name == "") {
            //             this.formData.name = "未命名"
            //         }
            //         if (!this.formData.content || this.formData.content == null ||  this.formData.content == "") {
            //             this.formData.content = "<span>&nbsp;</span>"
            //         }                    
            //         createDoc(this.formData.name, this.formData.content, 'question', this.formData.parentId).then((res) => {
            //             if (res.data.success == true) {
            //                 console.log("res.data===================",res.data);
            //                 let docData = res.data.result;
            //                 this.$forceUpdate();                         
            //                 this.$emit("refresh",  docData);
            //                 getMyFile(docData.id).then((res1) => {
            //                     console.log("getMyFile=====", res1.data)
            //                     this.formData = res1.data.result;
            //                     this.formData.name = docData.name;
            //                     let fileId = this.formData.id;
            //                     this.$refs.insertQuestionModal.newForm({id: newId, date: nowDate, fileId: fileId});
            //                 })                            
            //             }
            //         }) 

            //     } else {
            //         let fileId = this.formData.id;
            //         this.$refs.insertQuestionModal.newForm({id: newId, date: nowDate, fileId: fileId});
            //     }
            //     console.log("insertQuestion")
            // });
        },
        components:{RichText,PopupMenu,SendUpdateModal,FileLogModal,InsertTestModal,InsertQuestionModal},
        props:{
            title:{},
            open:{},
            mdata:{},
            files:{},
        },
        watch:{
            open: {
                handler(newValue) {
                    this.show = newValue;
                    if (newValue == true) {
                        this.formData = this.mdata;
                        if (this.mdata.id && this.mdata.id != null) {
                            editLogs(this.formData.id).then((res) => {
                                console.log(res);
                                if (res.data.success == true) {
                                    this.formData.editLogs = res.data.result;
                                }
                            })                                  
                        }  
                        // setTimeout(() => {
                        //     this.saveData1();               
                        // }, 15000);

                    } else {
                        this.formData.id = null;
                        this.formData.name = null;
                        this.formData.content = null;
                    }
                },
                immediate: true,
                deep: true 
            },

        },
        data() {
            return {
                show: null,
                formData:{
                },
                showInsertTestModal: false,
                showInsertQuestionModal: false,
                showSendUpdateModal: false,
                showFileLogModal:false,
                userName : sessionStorage.getItem("realname"),
                userId : sessionStorage.getItem("userId"),
                opMenuData: [
                    {id:'keep',name:'保留关键字所在行'},
                    {id:'sort',name:'倒序'},                   
                ],
            }
        },
        methods:{
            getTestFile() {
                let files = this.$refs.testFileAdd.files;
                console.log("files", files);

            },
            // insertQuestionConfirm(content) {
            //     console.log("question", content)
            //     let newId = getUUID()
            //     content.id = newId;
    
            //     getQuestionHtml(content).then((res) => {
            //         if (res.data.success == true) {     
            //             if  (this.formData.content == null) {
            //                 this.formData.content = ""
            //             }
            //             this.formData.content = objToStr(this.formData.content) + res.data.message;                     
            //             let postData = [];
            //             let fileId = this.formData.id;
            //             postData.push({"fileId": fileId, "dataId": content.id, "className": "question-item-index", "value":content.index});
            //             postData.push({"fileId": fileId, "dataId": content.id, "className": "question-item-title", "value": content.title}); 
            //             postData.push({"fileId": fileId, "dataId": content.id, "className": "question-item-option-a", "value":content.optionA}); 
            //             postData.push({"fileId": fileId, "dataId": content.id, "className": "question-item-option-b", "value":content.optionB}); 
            //             postData.push({"fileId": fileId, "dataId": content.id, "className": "question-item-option-c", "value":content.optionC}); 
            //             postData.push({"fileId": fileId, "dataId": content.id, "className": "question-item-option-d", "value":content.optionD}); 
            //             postData.push({"fileId": fileId, "dataId": content.id, "className": "question-item-result", "value": content.result}); 
                        
            //             saveAllHtml(postData).then((res) => {
            //                 if (res.data.success == true) {
            //                     this.showInsertQuestionModal = false;
            //                     this.$showToast({
            //                         msg: '操作成功！' 
            //                     }) 
            //                     this.$forceUpdate();
            //                 } else {
            //                     this.$showToast({msg: res.data.messeage})
            //                 }
            //             }) 

            //             this.showInsertTestModal = false;             
            //             this.$forceUpdate();
            //         } else {
            //             this.$showToast({msg: res.data.messeage})
            //         }
            //     }) 


            // },
            // insertTestConfirm(content) {
            //     console.log("test", content)
            //     let newId = getUUID()
            //     let nowDate = getJsDate(getNowDate());
            //     let creater = sessionStorage.getItem("realname");
            //     content.id = newId;
            //     content.date = nowDate;
            //     content.creater = creater;
            //     getTestHtml(content).then((res) => {
            //         if (res.data.success == true) {     
            //             if  (this.formData.content == null) {
            //                 this.formData.content = ""
            //             }
            //             this.formData.content = objToStr(this.formData.content) + res.data.message;                     
            //             let postData = [];
            //             let fileId = this.formData.id;
            //             postData.push({"fileId": fileId, "dataId": content.id, "className": "test-item-finish", "value":"完成"});
            //             postData.push({"fileId": fileId, "dataId": content.id, "className": "test-item-status", "value":"未完成"}); 
            //             postData.push({"fileId": fileId, "dataId": content.id, "className": "test-item-date", "value":nowDate}); 
            //             postData.push({"fileId": fileId, "dataId": content.id, "className": "test-item-level", "value":content.level}); 
            //             postData.push({"fileId": fileId, "dataId": content.id, "className": "test-item-duty-person", "value":content.dutyPerson}); 
            //             postData.push({"fileId": fileId, "dataId": content.id, "className": "test-item-tag", "value":content.tag}); 
            //             postData.push({"fileId": fileId, "dataId": content.id, "className": "test-item-verno", "value":content.verNo});
            //             postData.push({"fileId": fileId, "dataId": content.id, "className": "test-item-content", "value":content.content});
            //             postData.push({"fileId": fileId, "dataId": content.id, "className": "test-item-creater", "value":creater});
                        
            //             saveAllHtml(postData).then((res) => {
            //                 if (res.data.success == true) {
            //                     this.showInsertTestModal = false;
            //                     this.$showToast({
            //                         msg: '操作成功！' 
            //                     }) 
            //                     this.$forceUpdate();
            //                 } else {
            //                     this.$showToast({msg: res.data.messeage})
            //                 }
            //             }) 

            //             this.showInsertTestModal = false;             
            //             this.$forceUpdate();
            //         } else {
            //             this.$showToast({msg: res.data.messeage})
            //         }
            //     }) 
            // },
            confirm() {
                if (objToStr(this.formData.name) ==="") {
                    this.$showToast({
                        msg: '文件名称未填写' 
                    }) 
                    return false;
                }
                if (objToStr(this.formData.content).indexOf("data:image/png;base64") > -1) {
                    this.$showToast({
                        msg: '正在处理图片数据，请稍候' 
                    }) 
                    return false;
                }
                this.$emit("confirm", this.formData);

            },
            // saveData1() {
            //     if (this.show === true) {
            //         console.log("formData======", this.formData);
            //         let content = objToStr(this.formData.content);
            //         let fileName = objToStr(this.formData.name);
            //         if ((content !== "" ) && (fileName !== "")) {
            //             if (content.indexOf("data:image/png;base64") === -1) {
            //                 console.log("执行保存=========")
            //                 this.$emit("save", this.formData);
            //             }                       
            //         }  
            //         setTimeout(() => {
            //             this.saveData1();               
            //         }, 15000);                  
            //     }
            // },

            close() {
                this.$emit("close")
            },
            contentdo(event) {
                this.$refs.opMenu.show(event);//
            },
            sendUpdate() {
                this.showSendUpdateModal = true;
                console.log("下发更新")  
            },
            opMenuClick(id) {
                if (id == "update") {
                    this.showSendUpdateModal = true;
                    console.log("下发更新")      
                }
                if (id == "keep") {
                    this.$showInputBox({
                        caption:"提示",
                        inputValue: this.userName,
                        callback:(data) => {
                            this.formData.content = keepContent(this.formData.content, data);
                            this.$closeInputBox();
                            this.$forceUpdate();
                        }
                    })        
                }
                if (id == "sort") {
                    this.formData.content = sortContent(this.formData.content);       
                    this.$forceUpdate();
                }
            },  
            sendUpdateConfirm(data) {
                let postBody = [];
                console.log("files=====", this.files);
                console.log("data=====", data);
                let content = data.content;
                let allUser = data.allUser;
                let selectVer = data.selectVer;

                this.files.forEach(item => {
                    
                    if (content.length > 0) {
                        if (allUser == false) {
                            if (item.userId == selectVer) {
                                postBody.push({
                                    "content": content, 
                                    "msgType": 4,
                                    "toUserId": item.userId,
                                    "toUserName": item.userName,
                                    "fileId": item.id
                                }) 
                            }
                        }  
                    }                 
                });
                console.log("postBody=====", postBody);
                sendMsgs(postBody).then((res) => {
                    if (res.data.success == true) {
                        this.$showToast({
                            msg: '操作成功！' 
                        }) 
                        this.showSendUpdateModal = false;
                    }
                })                           
            },
            logs() {
                this.showFileLogModal = true;

            }

        }
   }
</script>

<style scoped>

    .form-modal {
        top: 15px;
    }
    .doc-edit-modal {
        width: 1100px;
        height: 835px;
    }
    .edit-area {
       width: 1060px;
    }

    .body .row {
        line-height: 40px;
    }
</style>


// WEBPACK FOOTER //
// src/views/modal/DocEditModal.vue